import React from "react"
import AppRoutes from "./AppRouter"

function App() {
  return <AppRoutes />
}

export default App
